import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogIn, Info } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { api } from '../lib/api';

export default function Login() {
  const [traderId, setTraderId] = useState('');
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    const res = await api.login(traderId.trim());
    setLoading(false);
    if (res.ok) navigate('/dashboard');
    else setMsg({ type: 'error', text: res.message });
  };

  return (
    <div className="alpha-bg min-h-screen">
      <Header />
      <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <div className="text-[11px] tracking-[0.35em] text-cyan-300/80">MEMBER ACCESS</div>
          <h1 className="font-display mt-2 text-4xl sm:text-5xl font-bold text-white">Login to <span className="text-cyan-gradient">Terminal</span></h1>
          <p className="mt-4 text-slate-400">Enter your approved Trader ID to enter the AI dashboard.</p>
        </div>

        <form onSubmit={submit} className="mt-10 glass-strong rounded-2xl p-6 sm:p-8 grid gap-4 fade-up">
          <label className="text-xs tracking-[0.25em] text-cyan-300/80">
            TRADER ID
            <input
              value={traderId}
              onChange={(e) => setTraderId(e.target.value.replace(/[^0-9]/g, ''))}
              placeholder="Enter your Trader ID"
              className="field-dark mt-1 w-full rounded-lg px-4 py-3 text-base font-mono tracking-wider"
              maxLength={12}
            />
          </label>

          {msg && (
            <div className="rounded-lg border px-3 py-2 text-sm flex items-start gap-2 border-rose-400/40 bg-rose-500/10 text-rose-200">
              <Info className="h-4 w-4 mt-0.5" /> <span>{msg.text}</span>
            </div>
          )}

          <button disabled={loading} className="btn-cyan rounded-lg px-4 py-3 text-sm tracking-widest uppercase inline-flex items-center justify-center gap-2 disabled:opacity-70">
            {loading ? 'Authenticating...' : (<><LogIn className="h-4 w-4" /> Enter Dashboard</>)}
          </button>

          <div className="text-center text-sm text-slate-400">
            Not verified yet? <Link to="/verify" className="text-cyan-300 hover:underline">Verify Trader ID</Link>
          </div>
        </form>
      </section>
      <Footer />
    </div>
  );
}
